import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaMapMarkerAlt } from 'react-icons/fa';

import styles from './CardEvents.module.css';

export default function CardEvents({ evento }) {

  function formatarData(dataISO) {
    const data = new Date(dataISO);

    const dia = data.getDate();
    const mes = data.toLocaleDateString('pt-BR', { month: 'long' });
    const ano = data.getFullYear();

    const hora = data.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    });

    return `Dia ${dia} de ${mes.charAt(0).toUpperCase() + mes.slice(1)} de ${ano} às ${hora}`;
  }

  return (
    <div className={styles.grid}>
      <div className={styles.card}>
        <Link to={`/evento/${evento.slug}`} className={styles.titulo}>
          <img src={evento.imagem} alt={evento.nome} className={styles.imagem} />
        </Link>
        <div className={styles.conteudo}>
          <Link to={`/evento/${evento.slug}`} className={styles.titulo}>
            {evento.nome}
          </Link>
          <p className={styles.info}>
            <FaCalendarAlt className={styles.icone} />
            {formatarData(evento.data)}
          </p>
          <p className={styles.info}>
            <FaMapMarkerAlt className={styles.icone} />
            {evento.endereco}
          </p>
        </div>
      </div>
    </div>
  )
}
